import { Outlet } from 'react-router-dom';

import { NewCVAnalysisLayoutContext } from '@/features/cv-analysis-new';

export const NewCVAnalysisLayout: React.FC = () => {
  return (
    <NewCVAnalysisLayoutContext>
      <Outlet />
    </NewCVAnalysisLayoutContext>
  );
};
